import React from "react";
import { Container } from "theme-ui";
import RichContent from "./richContent";

const ArticleBody = ({ body }) => (
  <Container variant="blog" sx={{mb:6}}>
    <RichContent html={body} />
  </Container>
);

export default ArticleBody;
